import { useQuery } from "@tanstack/react-query";
import { useApi } from "~/hooks/use-api";

export const useBisacSearchQuery = (query: string) => {
  const api = useApi();

  return useQuery({
    queryKey: ["bisac", "search", query],
    queryFn: () => api.bisac.search(query),
    enabled: Boolean(query),
    staleTime: Infinity,
    // A failed search shows at once; resubmitting the query refetches it.
    retry: false,
  });
};
